import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { DiscussionListConfig, Profile } from "../../../../shared";

@Component({
  selector: "bookmarked-discussions",
  templateUrl: "./bookmarked-discussions.component.html",
})
export class BookmarkedDiscussionsComponent implements OnInit {
  public profile: Profile;
  public config: DiscussionListConfig = new DiscussionListConfig();

  constructor(private route: ActivatedRoute) {
    this.route.parent.data.subscribe((data: { profile: Profile }) => {
      this.profile = data.profile;
      this.config.type = "BookmarkedDiscussionsFeed";
    });
  }

  ngOnInit() {}
}
